import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

/**
 * Returns name or email address from a email address wrapper
 * - Some email addresses can have an X500 address. Use Name in those cases.
 * - In oll other cases, if Name is present return it or else return the EmailAddress
 */
export const getNameOrAddressFromEmailAddressWrapper = (
    emailAddress: EmailAddressWrapper
): string =>
    emailAddress?.RoutingType?.toUpperCase?.() === 'EX'
        ? emailAddress?.Name || ''
        : emailAddress?.Name || emailAddress?.EmailAddress || '';
